<template>
  <div>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-clipboard-file-outline
          </v-icon>
          政令市
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <v-row>
      <v-col class="text-left">
        <h4>
          {{ total_count }} 件
        </h4>
      </v-col>
      <v-col class="text-right">
        <v-btn
          color="info"
          @click="addButtonClickEvent"
        >
          <v-icon>mdi-plus</v-icon>&nbsp;政令市の追加
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card class="rounded-card">
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="ordinance_cities"
              :items-per-page="-1"
              disable-pagination
              disable-sort
              hide-default-footer
            >
          
              <template v-slot:[`item.created_at`]="{ item }">
                {{ item.created_at | unix_datetime_format }}
              </template>
              <template v-slot:[`item.updated_at`]="{ item }">
                {{ item.updated_at | unix_datetime_format }}
              </template>
              <template v-slot:[`item.editable`]="{item}">
                <v-btn
                  v-if="$vuetify.breakpoint.mdAndUp"
                  color="info darken-2"
                  icon
                  @click="editButtonClickEvent(item)"
                >
                  <v-icon>mdi-note-edit</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="info"
                  @click="editButtonClickEvent(item)"
                >
                  編集する
                </v-btn>
                <v-btn
                  v-if="$vuetify.breakpoint.mdAndUp"
                  icon
                  color="error darken-2"
                  @click="deleteButtonClickEvent(item)"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="error"
                  @click="deleteButtonClickEvent(item)"
                >
                  削除する
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row
      v-if="hasResult"
      dense
    >
      <v-col>
        <v-pagination
          v-model="page"
          :length="pagination.total_pages"
          :total-visible="totalVisible"
          circle
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          @input="changePage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <!-- /ダイアログ -->
    <ordinance-city-dialog
      :enable-dialog="enableOrdinanceCityDialog"
      :target-id="targetId"
      @closeEvent="closeOrdinanceCityDialog"
      @registerEvent="ordinanceCityCallback"
    />
    <!-- ダイアログ -->

    <confirm ref="confirm" />
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import Confirm from '../../../../components/Confirm'
import OrdinanceCityDialog from './dialogs/OrdinanceCityRegistDialog'
export default {
  name: 'DriverOrdinanceCitiesIndex',
  components: {
    Confirm,
    OrdinanceCityDialog
  },
  mixins: [],
  data () {
    return {
      page: 1,
      totalVisible: 7,
      total_count: null,
      targetId: null,
      enableOrdinanceCityDialog: false,
      tableHeaders: [
        { value: 'prefecture_name', text: '都道府県' },
        { value: 'code', text: 'コード' },
        { value: 'name', text: '政令市' },
        { value: 'created_at', text: 'データ作成日時' },
        { value: 'updated_at', text: 'データ更新日時' },
        { value: 'editable', text: '', align: 'end' },
      ],
      ordinance_cities: [],
    }
  },
  computed: {
    ...mapState('AdminMasterOrdinanceCity', {
      pagination: 'pagination',
    }),
    ...mapGetters('AdminMasterOrdinanceCity', [
      'hasResult'
    ]),
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.page = this.pagination.current_page
    this.searchOrdinanceCity()
  },
  methods: {
    ...mapActions('AdminMasterOrdinanceCity', {
      fetchOrdinanceCities: 'index',
      deleteOrdinanceCity: 'destroy',
      resetState: 'resetState',
      resetPagination: 'resetPagination',
    }),
    addButtonClickEvent () {
      this.targetId = null
      this.enableOrdinanceCityDialog = true
    },
    editButtonClickEvent (item) {
      this.targetId = item.id
      this.enableOrdinanceCityDialog = true
    },
    closeOrdinanceCityDialog () {
      this.enableOrdinanceCityDialog = false;
    },
    ordinanceCityCallback (forms) {
      this.closeOrdinanceCityDialog()
      this.searchOrdinanceCity ()
    },
    searchButtonClickEvent () {
      this.page = 1
      this.searchOrdinanceCity()
    },
    deleteButtonClickEvent (item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteOrdinanceCity({id: item.id }).then(() =>{
            this.searchOrdinanceCity ()
          })
        }
      })
    },
    changePage () {
      this.searchOrdinanceCity()
    },
    searchOrdinanceCity () {
      let params = { 
        page: this.page,
      }
      this.fetchOrdinanceCities(params).then((content) => {
        this.ordinance_cities = content.ordinance_cities
        this.total_count = content.pagination.total_count
      })
    }
  }
}
</script>
